import React from 'react';
import PropTypes from 'prop-types';

import Accordion from '../Accordion';
import { SubtitleSecondary } from '../Base';
import CheckListItem from '../CheckListItem';
import TechSpecRow from '../TechSpecRow';

const PhoneDetailsInfoSection = props => {
  let { specifications, whatsInTheBox } = props;

  return (
    <Accordion
      panels={[
        {
          key: 'tech-specs',
          title: `Tech Specs`,
          content: specifications.map((spec, index, filteredSpecs) => {
            // Hide HR on the last item
            const showHR = index < filteredSpecs.length - 1;

            const { groupTitle, fields } = spec;
            const content = fields.map(field => field.value);

            return (
              <TechSpecRow
                key={groupTitle}
                title={groupTitle}
                content={content}
                showHR={showHR}
              />
            );
          })
        },
        {
          key: 'whats-in-the-box',
          title: `What's in the Box`,
          content: whatsInTheBox.map((boxItem, index) => {
            return (
              <CheckListItem key={index}>
                <SubtitleSecondary>{boxItem}</SubtitleSecondary>
              </CheckListItem>
            );
          })
        }
      ]}
    />
  );
};

PhoneDetailsInfoSection.propTypes = {
  specifications: PropTypes.string,
  whatsInTheBox: PropTypes.arrayOf(PropTypes.string)
};

export default PhoneDetailsInfoSection;
